























import Vue from 'vue'
import TeamOne from './TeamOne.vue'
import TeamTwo from './TeamTwo.vue'

export default Vue.extend({
  name: 'scoreboard',
  components: { TeamOne, TeamTwo }
})
